import { memo, useEffect, useMemo, useState } from "react";

export const useGenerateTableMapOptions = (
  source: any[],
  fromKey: string,
  toKey: string
) => {
  const [data, setData] = useState<{ from: any; to: any }[]>([]);

  const transformedData = useMemo(() => {
    if (!source || source.length === 0) return [];
    return source.map((item) => ({
      from: item[fromKey],
      to: item[toKey],
    }));
  }, [source, fromKey, toKey]);

  useEffect(() => {
    setData((prev) =>
      JSON.stringify(prev) === JSON.stringify(transformedData)
        ? prev
        : transformedData
    );
  }, [transformedData]);

  return {
    data,
  };
};
